import { isAdvancedCobranding, useCobranding } from '../../../utilities/cobranding/cobranding';

export const useShouldOrchestrate = () => {
  const { cobranding } = useCobranding();
  const forceOrchestration = isAdvancedCobranding(cobranding);

  return forceOrchestration;
};
